import React from 'react';
import { List } from 'react-admin';
import InsightsGrid from '../../components/InsightsGrid';

class HudList extends React.Component {
    render() {
        return (
            <List title="Your pinned insights" {...this.props}>
                <InsightsGrid />
            </List>
        );
    }
}

export default HudList;


// WEBPACK FOOTER //
// ./src/pages/lists/Hud.js